import { Hub } from '../hub/hub';
import { SocialNetWorkThread } from '../social-network-thread';
import { ClinicalCasePatientInformation } from './clinical-case-patient-information';
import { ClinicalCaseSurveyOption } from './clinical-case-survey-option';

export class ClinicalCase extends SocialNetWorkThread {
  public hub?: Hub;
  public options?: ClinicalCaseSurveyOption[];
  public patientInformation?: ClinicalCasePatientInformation;
  public question?: string;
  public selectedOptionId?: string;
}
